import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class NotifyAPIUpdateService {

  private apiDataSubject = new Subject<any>();

  sendAPIData(data: any) {
    this.apiDataSubject.next(data)
  }

  getAPIData(): Observable<any> {
    return this.apiDataSubject.asObservable();
  }
}
